import React from "react";
import styles from "./KPICardWithTrend.module.css";
import Skeleton from "./Skeleton";


const KPICardWithTrend = ({ 
  title, 
  value, 
  trend, 
  isPositive = true,
  className,
  style,
  isLoading = false
}) => {
  const formatValue = (val) => {
    if (typeof val === "number") {
      return val.toLocaleString();
    }
    return val;
  };

  return (
    <div className={`${styles.kpiCard} ${className || ""}`} style={style}>
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.valueRow}>
        {isLoading ? (
          <Skeleton width="80px" height="22px" radius="999px" />
        ) : (
          <span className={styles.value}>{formatValue(value)}</span>
        )}
        {!isLoading && trend && (
          <span className={`${styles.trend} ${isPositive ? styles.positive : styles.negative}`}>
            {trend}
          </span>
        )}
      </div>
    </div>
  );
};

export default KPICardWithTrend;

